<template>
  <Card
    title="Experience Info"
    direction="column"
    color="background"
    background="grey"
  >
    <TextComponent color="background" type="paragraparagraphph" as="p">
      GitHub:
      <TextComponent
        rel="noreferrer noopener"
        :href="linkify(data.hackerApplication.githubLink)"
        color="background"
        type="heading4"
        target="_blank"
        as="a"
      >
        {{ data.hackerApplication.githubLink }}
      </TextComponent>
    </TextComponent>
    <TextComponent color="background" type="paragraph" as="p">
      Portfolio:
      <TextComponent
        rel="noreferrer noopener"
        :href="linkify(data.hackerApplication.portfolioLink)"
        color="background"
        target="_blank"
        type="heading4"
        as="a"
      >
        {{ data.hackerApplication.portfolioLink }}
      </TextComponent>
    </TextComponent>
    <TextComponent color="background" type="paragraph" as="p">
      LinkedIn:
      <TextComponent
        :href="linkify(data.hackerApplication.linkedinLink)"
        as="a"
        color="background"
        rel="noreferrer noopener"
        target="_blank"
        type="paragraph"
      >
        {{ data.hackerApplication.linkedinLink }}
      </TextComponent>
    </TextComponent>
    <TextComponent
      as="p"
      color="background"
      type="paragraph"
      v-if="this.data.hackerApplication.resumeFileName"
    >
      Resume:
      <TextComponent
        rel="noreferrer noopener"
        color="background"
        target="_blank"
        type="paragraph"
        :href="blob"
        as="a"
      >
        View resume
      </TextComponent>
    </TextComponent>
    <TextComponent color="background" type="paragraph" as="p">
      Hackathon Count: {{ data.hackerApplication.hackathonsAttended }}
    </TextComponent>
  </Card>
</template>

<script>
  import TextComponent from '@hackthe6ix/vue-ui/Text';
  import swal from 'sweetalert';
  import Card from '../../../../containers/Card';
  import { getFileURL } from '../../../../utils/api';

  export default {
  name: 'ExperienceInfo',
  data() {
    return {
      blob: undefined,
    };
  },
  components: {
    TextComponent,
    Card,
  },
  async mounted() {
    if (this.data.hackerApplication.resumeFileName) {
      const resumeResponse = await getFileURL(
        this.data.hackerApplication.resumeFileName,
      );

      if (resumeResponse.success) {
        this.blob = window.URL.createObjectURL(
          new Blob([resumeResponse.data], { type: 'application/pdf' }),
        );
      } else {
        swal('Error', 'Could not fetch resume', 'error');
      }
    }
  },
  beforeDestroy() {
    URL.revokeObjectURL(this.blob);
  },
  methods: {
    linkify(_) {
      if (_?.startsWith('http')) return _;
      return `https://${_}`;
    },
  },
  props: {
    data: Object,
  },
};
</script>
